export enum pageTypes {
  PDP_FINISHED_PRODUCT = 'PDP_FINISHED_PRODUCT',
  CART = 'CART',
  PDP_ACCESSORY = 'PDP_ACCESSORY',
  CSP_ACCESSORY = 'CSP_ACCESSORY',
  CSP_IFU = 'CSP_IFU',
  ACCESSORY_HOME = 'ACCESSORY_HOME',
  HOMEPAGE = 'HOMEPAGE',
  CATEGORY_MARKETING = 'CATEGORY_MARKETING',
  CSC_ACCESSORY = 'CSC_ACCESSORY',
  CSC_IFU = 'CSC_IFU',
  NGT = 'NGT',
  SERVICE = 'SERVICE',
  MY_ACCOUNT = 'MY_ACCOUNT',
  SALES_CONDITIONS = 'SALES_CONDITIONS',
  SEARCH = 'SEARCH',
  RECIPE = 'RECIPE',
  PDP_BUNDLE = 'PDP_BUNDLE'
}
